import { AbstractControl, ValidationErrors } from '@angular/forms';
import _has from 'lodash-es/has';

export function backendApiValidator(control: AbstractControl): ValidationErrors | null {
  if (_has(control, 'errors.backend')) {
    return { backend: control.errors.backend };
  }
  return null;
}
